export const isNotFoundSpaceError = (error: any) => error?.message?.includes('Cannot find space');
